import type { QuestionChoice } from '@exam-management/graphql';
import { ContentPreviewer, type FlexProps, DoneIcon, Flex, styled, Text } from '@shared/components';
import { useMemo } from 'react';

const QuestionChoiceListWrapper = styled(Flex)({ flexDirection: 'column' });

const QuestionChoiceListItemWrapper = styled(Flex)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: theme.shape.rounded(1),
  gap: theme.spacing(2.5),
}));

export interface QuestionChoiceListForQuestionCreationProps {
  choices: QuestionChoice[];
  value: string;
  sx?: FlexProps['sx'];
}

export default function QuestionChoiceListForQuestionCreation(
  props: Readonly<QuestionChoiceListForQuestionCreationProps>,
) {
  const { choices, value, ...restProps } = props;

  const orderedChoices = useMemo(() => [...choices].sort((a, b) => a.order - b.order), [choices]);

  return (
    <QuestionChoiceListWrapper {...restProps}>
      {orderedChoices.map((choice) => {
        const { value: choiceValue, label, order } = choice;
        const isCorrect = value === choiceValue;

        return (
          <QuestionChoiceListItemWrapper
            key={choiceValue}
            sx={{ backgroundColor: isCorrect ? 'success.light' : 'unset' }}
          >
            <DoneIcon
              color='success'
              sx={{ visibility: isCorrect ? 'visible' : 'hidden', height: 24, width: 24 }}
            />
            <Text sx={{ flexShrink: 0 }}>{order}.</Text>
            <ContentPreviewer content={label} />
          </QuestionChoiceListItemWrapper>
        );
      })}
    </QuestionChoiceListWrapper>
  );
}
